import React from 'react'
import { FunctionField, RaRecord, useLocaleState, FunctionFieldProps } from 'react-admin'
import { branchConfigTimeConverter } from '../../../utils/times'

export interface BranchConfigTimeFieldProps extends Omit<FunctionFieldProps, 'render'> {
  format?: string
  source: string
  showTime?: boolean
}

export const BranchConfigTimeField: React.FC<BranchConfigTimeFieldProps> = ({
  source,
  showTime = false,
  ...props
}) => {
  const [activeLocale] = useLocaleState()

  const render = (record: RaRecord): string => {
    if (!record || record[source] === undefined) return null
    const convertOpenTime = record[source]
    const time = branchConfigTimeConverter(convertOpenTime)
    return activeLocale === 'th'
      ? time.locale('th').format(showTime ? 'HH:mm น.' : '')
      : time.format(showTime ? 'HH:mm' : '')
  }

  return <FunctionField render={render} {...props} />
}
